module.exports = __webpack_public_path__ + "static/team-grow-5a3d5991265cc96596eca186fc4e5ea5.jpeg";